import { render, staticRenderFns } from "./majorSource.vue?vue&type=template&id=101394e6&scoped=true"
import script from "./majorSource.vue?vue&type=script&lang=js"
export * from "./majorSource.vue?vue&type=script&lang=js"
import style0 from "./majorSource.vue?vue&type=style&index=0&id=101394e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101394e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101394e6')) {
      api.createRecord('101394e6', component.options)
    } else {
      api.reload('101394e6', component.options)
    }
    module.hot.accept("./majorSource.vue?vue&type=template&id=101394e6&scoped=true", function () {
      api.rerender('101394e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collegeEdition/majorSource.vue"
export default component.exports